import React from "react";
import { Radio } from "lucide-react";

export default function NewsTicker({ quakes }) {
  const items = quakes.slice(0, 30);
  const line = items.map((q) => {
    const t = new Date(q.time).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
    return `[${q.source}] ${t} · M ${q.magnitude?.toFixed(1)} · ${q.location} · Depth ${q.depth?.toFixed(0)} km`;
  });
  const joined = line.join("   ◆   ");

  return (
    <div
      className="ticker-wrap fixed bottom-0 left-0 right-0 z-30 flex items-center gap-3 border-t border-slate-800/80 bg-slate-950/95 px-3 py-1.5 backdrop-blur-xl"
      data-testid="news-ticker"
    >
      <div className="flex items-center gap-2 shrink-0">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75"></span>
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500"></span>
        </span>
        <Radio className="h-3.5 w-3.5 text-slate-400" />
        <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Live</span>
      </div>
      <div className="flex-1 overflow-hidden">
        <div className="ticker-track font-mono text-xs text-slate-300">
          <span className="pr-12">{joined}</span>
          <span className="pr-12">{joined}</span>
        </div>
      </div>
    </div>
  );
}
